import { reducer, union } from "ts-action";
import { on } from "ts-action-immer";
import { ByIdReducerState } from "../types";
import * as AC from "../actionCreators";
import modelReducer from "./modelReducer";
import invalidatedDatasetsForTemplateIdReducer from "./invalidatedDatasetsForTemplateIdReducer";

const initialState: ByIdReducerState = {};

const byIdReducer = reducer(
  initialState,
  on(
    ...union(
      AC.receiveTemplateBuilder,
      AC.updateTemplateBuilder,
      AC.revalidateTemplateBuilder,
      AC.isFetchingModel,
      AC.updateDataTemplate,
      AC.updateDataTemplateItems,
      AC.updateDataTemplateItem,
      AC.updatePresentationTemplate,
      AC.updatePresentationTemplateItems,
      AC.updatePresentationTemplateItem,
      AC.updateBothTemplateItems,
      AC.updateDetailTemplates,
      AC.updateDetailTemplatesOrder,
      AC.addNewDAndPTemplateItem,
      AC.deleteDAndPTemplateItem,
      AC.receiveEditRow,
      AC.updateTemplateBuilderEditRow,
      AC.isFetchingEditRow,
      AC.receiveSqlQuery,
      AC.isFetchingSqlQuery,
      AC.receiveTemplateBuilderModels,
      AC.setStateChanged
    ),
    (state, action) => {
      const { templateBuilderId } = action.payload;
      if (action.error) return;

      state[templateBuilderId] = modelReducer(state[templateBuilderId], action);
    }
  ),

  on(AC.invalidateDatasetForAllTemplates, (state, action) => {
    Object.keys(state)
      .map(Number)
      .forEach((templateId) => {
        const subreducer = invalidatedDatasetsForTemplateIdReducer;
        state[templateId].invalidatedDatasets = subreducer(
          state[templateId].invalidatedDatasets,
          action
        );
      });
  }),

  on(AC.revalidateDatasetForTemplate, (state, action) => {
    const { templateId } = action.payload;
    if (!state[templateId]) return;
    const subreducer = invalidatedDatasetsForTemplateIdReducer;
    state[templateId].invalidatedDatasets = subreducer(
      state[templateId].invalidatedDatasets,
      action
    );
  }),

  on(AC.invalidateWholeStateForTemplate, (state, action) => {
    const { templateId } = action.payload;
    delete state[templateId];
  })
);
export default byIdReducer;
